var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "wrapper relative form-input flex-1 block sm:text-sm sm:leading-5 focus:shadow-none outline-none focus:outline-none focus:border-primary disabled:bg-input-disabled disabled:border-gray-200",
    },
    [
      _c("div", { staticClass: "icon-holder" }, [
        _c("span", { staticClass: "icon" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z",
                  stroke: "#717986",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M14.0001 14L11.1001 11.1",
                  stroke: "#717986",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]),
      ]),
      _c("input", {
        staticClass:
          "searchv2 placeholder:text-sm ml-6 focus:shadow-none outline-none focus:outline-none",
        class: _vm.classes,
        attrs: {
          id: _vm.id,
          name: _vm.name,
          type: _vm.type,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.value },
        on: {
          input: _vm.handleInput,
          blur: function ($event) {
            return _vm.$emit("blur")
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.$emit("enter")
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }